import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import TestAPI from './pages/TestAPI';
import Settings from './pages/Settings';
import Logs from './pages/Logs';
import Media from './pages/Media';
import Scheduler from './pages/Scheduler';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import React from 'react';
import Cookies from 'js-cookie';

function AppLayout() {
  const location = useLocation();
  const token = Cookies.get('authToken');

  const hideSidebar = location.pathname === '/' || !token;

  return (
    <div className="flex min-h-screen">
      {!hideSidebar && <Sidebar />}
      <div className="flex-1">
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test-api"
            element={
              <ProtectedRoute>
                <TestAPI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <Logs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute>
                <Media />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduler"
            element={
              <ProtectedRoute>
                <Scheduler />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}